<template>
  <section class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Články - Typy - Tým - Upravit <span class="text-primary">#{{ this.id }}</span></strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          label="Název"
          :validate-status="error('ale_name') ? 'error' : ''"
          :help="error('ale_name') || ''"
        >
          <a-input placeholder="Název" v-decorator="['ale_name', {rules: [{max: 60, message: 'Název nemůže být delší než 100 znaků!'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Nadpis tučně"
          :validate-status="error('ale_title') ? 'error' : ''"
          :help="error('ale_title') || ''"
        >
          <a-input placeholder="Nadpis tučně" v-decorator="['ale_title', {rules: [{max: 60, message: 'Nadpis tučně nemůže být delší než 60 znaků!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Nadpis kurzivou"
          :validate-status="error('ale_title_thin') ? 'error' : ''"
          :help="error('ale_title_thin') || ''"
        >
          <a-input placeholder="Nadpis kurzivou" v-decorator="['ale_title_thin', {rules: [{max: 60, message: 'Nadpis kurzivou nemůže být delší než 60 znaků!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Popisek"
          :validate-status="error('ale_description') ? 'error' : ''"
          :help="error('ale_description') || ''"
        >
          <a-input
            type="textarea"
            :autoSize="{ minRows: 4, maxRows: 10 }"
            placeholder="Popisek"
            v-decorator="['ale_description']"
          />
        </a-form-item>

        <a-form-item>
          <span slot="label">
            Obrázky&nbsp;
            <a-tooltip title="Vyber si obrázek pro jednotlivé zaměstnance.">
              <a-icon type="question-circle-o"/>
            </a-tooltip>
          </span>
          <a-row class="pb-5" type="flex" justify="center">
            <a-col :span="8">
              <a-input-search
                placeholder="Hledat..."
                v-model="image.search"
              />
            </a-col>
          </a-row>
          <div v-if="images.data.length > 0">
            <a-row>
              <a-col :key="'all'+index" v-for="(item, index) in images.data" :xl="4" :md="6" :sm="8" :xs="12">
                <div :class="[$style.item, $style.withControls]">
                  <img v-if="!image.errors.includes(item.iae_id)" class="img-fluid" :src="$uploadImagePath + item.iae_path + '_6.' + item.iae_format" @error="image.errors.push(item.iae_id)">
                  <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
                  <div :class="$style.itemControls">
                    <span :class="$style['item-name']">{{ toImageName(item.iae_name) }}</span>
                    <a-tooltip placement="bottom" title="Číslo zaměstnance">
                      <a-input-number
                        v-if="form.getFieldValue('items') !== undefined && form.getFieldValue('items').length > 0"
                        :min="1"
                        :max="form.getFieldValue('items').length"
                        size="small"
                        style="margin-right: 5px;"
                        v-decorator="[`itemNumber[${index}]`, { initialValue: 1 }]"
                      />
                    </a-tooltip>
                    <a-button size="small" icon="edit" @click="changeImage(item, form.getFieldValue('itemNumber['+ index + ']') || 1)"></a-button>
                  </div>
                </div>
              </a-col>
            </a-row>
            <a-row class="pb-5 pt-5" type="flex" justify="center">
              <a-col :span="8">
                <a-button v-if="imageNextCount > 0" type="primary" class="width-200 d-block m-auto" @click="onNextImagesClick">Načíst další...</a-button>
              </a-col>
            </a-row>
          </div>
          <a-empty v-else>
            <a-spin v-if="!image.loaded" />
          </a-empty>
        </a-form-item>

        <a-form-item
          label="Zaměstnance"
          :required="true"
        >
          <a-row v-for="(k, index) in form.getFieldValue('items')"
                 :key="index">
            <a-col :offset="1" :span="21">
              <a-form-item
                label="Fotka"
                :required="true"
              >
                <a-col :xl="4" :md="6" :sm="8" :xs="12">
                  <div v-if="image.selected[index] !== undefined" :class="[$style.item, $style.withControls]">
                    <img v-if="!image.errors.includes(image.selected[index].iae_id)" class="img-fluid" :src="$uploadImagePath + image.selected[index].iae_path + '_6.' + image.selected[index].iae_format" @error="image.errors.push(image.selected[index].iae_id)">
                    <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
                    <div :class="$style.itemControls">
                      <span :class="$style['item-name']">{{ toImageName(image.selected[index].iae_name) }}</span>
                    </div>
                  </div>
                  <div v-else>
                    <div :class="[$style.item]">
                      <a-icon theme="twoTone" twoToneColor="#ccc" type="exclamation-circle" />
                    </div>
                    <small class="d-block ml-3">Vyber si obrázek pro tohoto zaměstnance!</small>
                  </div>
                </a-col>
              </a-form-item>

              <a-form-item
                label="Jméno"
                :validate-status="error(`name[${index}]`) ? 'error' : ''"
                :help="error(`name[${index}]`) || ''"
              >
                <a-input v-decorator="[`name[${index}]`, { validateTrigger: ['change', 'blur'], rules: [{ required: true, message: 'Jméno musí být vyplněno!'}]}]"
                         placeholder="Jméno"
                >
                </a-input>
              </a-form-item>

              <a-form-item
                label="Pracovní pozice"
                :validate-status="error(`job[${index}]`) ? 'error' : ''"
                :help="error(`job[${index}]`) || ''"
              >
                <a-input v-decorator="[`job[${index}]`, { validateTrigger: ['change', 'blur'], rules: [{ required: true, message: 'Pracovní pozice musí být vyplněna!' }]}]"
                         placeholder="Pracovní pozice"
                />
              </a-form-item>

              <a-form-item
                label="Facebook"
              >
                <a-input v-decorator="[`facebook[${index}]`]"
                         placeholder="Facebook"
                />
              </a-form-item>

              <a-form-item
                label="Instagram"
              >
                <a-input v-decorator="[`instagram[${index}]`]"
                         placeholder="Instagram"
                />
              </a-form-item>

              <a-form-item
                label="Twitter"
              >
                <a-input v-decorator="[`twitter[${index}]`]"
                         placeholder="Twitter"
                />
              </a-form-item>

            </a-col>
            <a-col :span="2">
              <a-icon
                v-if="form.getFieldValue('items').length > 1"
                class="dynamic-delete-button"
                type="minus-circle-o"
                :disabled="form.getFieldValue('items').length === 1"
                @click="() => removeItem(index)"
              />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <a-button
            class="m-auto d-block"
            type="dashed"
            @click="addItem"
            style="width: 200px;"
          >
            <a-icon type="plus" /> Přidat další
          </a-button>
        </a-form-item>

        <a-form-item label="Zveřejnit?">
          <a-checkbox v-decorator="['ale_is_active', { valuePropName: 'checked', initialValue: true }]"/>
        </a-form-item>

        <a-form-item label="Přidat mezeru pod článek?">
          <a-checkbox v-decorator="['gap', { valuePropName: 'checked', initialValue: true }]"/>
        </a-form-item>

        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || verifyImages() || hasErrors(form.getFieldsError())">Upravit</a-button>
        </div>
      </a-form>
    </div>
  </section>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '../../../../services/forms'

export default {
  components: {
    ActionTools, LanguageTab,
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
    this.form.getFieldDecorator('items', { initialValue: [], preserve: true })
  },
  data() {
    return {
      hasErrors,
      id: this.$route.params.id,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/article/type/mom',
          title: 'Seznam',
        },
      ],
      item: {
        languages: [],
      },
      image: {
        search: '',
        page: 1,
        loaded: false,
        trigger: false,
        errors: [],
        selected: [],
      },
      formItemLayout: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
      },
      loaded: [],
    }
  },
  computed: {
    currentDetailLang: function() {
      return this.$store.getters['article/currentLanguageDetail']
    },
    detail: function() {
      return this.$store.getters['article/getDetail']
    },
    images: function () {
      return this.$store.getters['image/filteredItems']({ searchText: this.image.search, page: this.image.page })
    },
    imageNextCount: function () {
      const imageCount = this.images.count - this.images.data.length
      return imageCount > 6 ? 6 : imageCount
    },
    language: function () {
      return this.$store.getters['language/active']
    },
  },
  methods: {
    verifyImages() {
      let result = false
      this.image.selected.some(value => {
        if (value === undefined) {
          result = true
          return true
        }
      })
      return result
    },
    changeImage(image, destinationIndex) {
      const index = destinationIndex - 1
      this.image.selected[index] = image
      this.form.setFieldsValue({
        items: this.form.getFieldValue('items').concat({
          social: [],
          image: undefined,
          name: undefined,
          job: undefined,
        }),
      })
      const items = this.form.getFieldValue('items')
      items.pop()
      this.form.setFieldsValue({
        items: items,
      })
    },
    removeItem(index) {
      const items = this.form.getFieldValue('items')
      if (items.length === 1) {
        return
      }
      const names = this.form.getFieldValue('name')
      const jobs = this.form.getFieldValue('job')
      const facebooks = this.form.getFieldValue('facebook')
      const twitters = this.form.getFieldValue('twitter')
      const instagrams = this.form.getFieldValue('instagram')
      items.splice(index, 1)
      names.splice(index, 1)
      jobs.splice(index, 1)
      facebooks.splice(index, 1)
      twitters.splice(index, 1)
      instagrams.splice(index, 1)
      this.form.setFieldsValue({
        items: items,
        name: names,
        job: jobs,
        facebook: facebooks,
        twitter: twitters,
        instagram: instagrams,
      })
    },
    toImageName: function (name) {
      const maxLength = 30
      const nameSubstring = name.substring(0, maxLength)
      return nameSubstring.length !== maxLength ? nameSubstring : nameSubstring + '...'
    },
    onNextImagesClick() {
      this.image.page += 1
    },
    addItem() {
      const newIndex = this.form.getFieldValue('items').length
      this.image.selected.push(undefined)
      this.form.getFieldDecorator(`name[${newIndex}]`)
      this.form.getFieldDecorator(`job[${newIndex}]`)
      this.form.getFieldDecorator(`twitter[${newIndex}]`)
      this.form.getFieldDecorator(`facebook[${newIndex}]`)
      this.form.getFieldDecorator(`instagram[${newIndex}]`)
      this.form.setFields({
        items: {
          value: this.form.getFieldValue('items').concat({
            social: [],
            image: undefined,
            name: undefined,
            job: undefined,
          }),
        },
        ['name[' + newIndex + ']']: { value: undefined, errors: ['Jméno musí být vyplněno!'] },
        ['twitter[' + newIndex + ']']: { value: undefined },
        ['facebook[' + newIndex + ']']: { value: undefined },
        ['instagram[' + newIndex + ']']: { value: undefined },
        ['job[' + newIndex + ']']: { value: undefined, errors: ['Pracovní pozice musí být vyplněna!'] },
      })
      this.form.validateFields()
    },
    initData() {
      Promise.all([
        this.$store.dispatch('image/getList'),
      ])
        .then(() => {
          this.initDetail()
        })
        .catch(() => {})
        .finally(() => {
          this.loaded.push(this.language)
          this.image.loaded = true
        })
    },
    initDetail() {
      this.loading = true
      this.$store.dispatch('article/getOne', { id: this.id, type: 'MOM' })
        .then(() => {
          this.item = Object.assign({}, this.detail)
          this.form.setFieldsValue({
            gap: this.currentDetailLang.ale_content === undefined ? true : this.currentDetailLang.ale_content.gap,
            ale_name: this.currentDetailLang.ale_name,
            ale_title_thin: this.currentDetailLang.ale_title_thin,
            ale_title: this.currentDetailLang.ale_title,
            ale_description: this.currentDetailLang.ale_description,
            ale_is_active: this.currentDetailLang.ale_is_active,
            items: this.currentDetailLang.ale_content === undefined ? [{
              social: [],
              image: undefined,
              name: undefined,
              job: undefined,
            }] : this.currentDetailLang.ale_content.items,
          })
          this.image.selected = []
          this.form.getFieldValue('items').forEach((value, key) => {
            let facebook, twitter, instagram
            if (value.social.length > 0) {
              facebook = value.social.find(x => x.name === 'facebook')
              twitter = value.social.find(x => x.name === 'twitter')
              instagram = value.social.find(x => x.name === 'instagram')
            }
            this.image.selected.push(value.image)
            this.form.getFieldDecorator(`name[${key}]`)
            this.form.getFieldDecorator(`job[${key}]`)
            this.form.getFieldDecorator(`facebook[${key}]`)
            this.form.getFieldDecorator(`twitter[${key}]`)
            this.form.getFieldDecorator(`instagram[${key}]`)
            this.form.setFields({
              ['facebook[' + key + ']']: { value: facebook !== undefined ? facebook.link : undefined },
              ['twitter[' + key + ']']: { value: twitter !== undefined ? twitter.link : undefined },
              ['instagram[' + key + ']']: { value: instagram !== undefined ? instagram.link : undefined },
              ['name[' + key + ']']: { value: value.name, errors: value.name === undefined || value.name.trim().length === 0 ? ['Nadpis musí být vyplněn!'] : undefined },
              ['job[' + key + ']']: { value: value.job, errors: value.job === undefined || value.job.trim().length === 0 ? ['Práce musí být vyplněn!'] : undefined },
            })
          })
          this.image.trigger = !this.image.trigger
          this.form.validateFields()
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.handleChange(this.language)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('article/put', { id: this.item.ate_id, item: this.getData() })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    getData() {
      return {
        languages: this.item.languages.filter(x => x.ale_name !== undefined && x.ale_name.trim().length > 0).map(x => {
          return {
            lge_id: x.lge_id,
            ale_title_thin: x.ale_title_thin !== undefined ? x.ale_title_thin : null,
            ale_content: {
              gap: x.ale_content.gap,
              items: x.ale_content.items.map(item => {
                return {
                  image: item.image,
                  name: item.name,
                  job: item.job,
                  social: item.social.filter(soc => soc.link !== undefined),
                }
              }),
            },
            ale_description: x.ale_description !== undefined ? x.ale_description : null,
            ale_title: x.ale_title !== undefined ? x.ale_title : null,
            ale_name: x.ale_name !== undefined ? x.ale_name : null,
            ale_is_active: x.ale_is_active,
          }
        }),
      }
    },
    handleChange(oldLanguage) {
      const foundObj = { article: false }
      const newObj = {
        article: {
          lge_id: oldLanguage,
          ale_content: {
            gap: this.form.getFieldValue('gap'),
            items: this.form.getFieldValue('items').map((x, y) => {
              return {
                social: [{
                  name: 'facebook',
                  link: this.form.getFieldValue('facebook[' + y + ']'),
                }, {
                  name: 'instagram',
                  link: this.form.getFieldValue('instagram[' + y + ']'),
                }, {
                  name: 'twitter',
                  link: this.form.getFieldValue('twitter[' + y + ']'),
                }],
                image: this.image.selected[y],
                name: this.form.getFieldValue('name[' + y + ']'),
                job: this.form.getFieldValue('job[' + y + ']'),
              }
            }),
          },
          ale_name: this.form.getFieldValue('ale_name'),
          ale_title_thin: this.form.getFieldValue('ale_title_thin'),
          ale_title: this.form.getFieldValue('ale_title'),
          ale_description: this.form.getFieldValue('ale_description'),
          ale_is_active: this.form.getFieldValue('ale_is_active'),
        },
      }
      this.item.languages.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item.languages[key] = newObj.article
          foundObj.article = true
          return true
        }
      })
      if (!foundObj.article) {
        this.item.languages.push(newObj.article)
      }
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
    refreshComponent(id) {
      this.id = id
      this.item = {
        languages: [],
      }
      this.image = {
        search: '',
        page: 1,
        loaded: false,
        trigger: false,
        errors: [],
        selected: [],
      }
      this.loaded = []
    },
  },
  created() {
    if (this.language !== null) {
      this.initData()
    }
  },
  watch: {
    '$route.params.id'(newId, oldId) {
      this.refreshComponent(newId)
      if (this.language !== null) {
        this.initData()
      }
    },
    language(newValue, oldValue) {
      if (oldValue !== null) {
        this.handleChange(oldValue)
      }
      if (newValue !== null) {
        if (!this.loaded.includes(this.language)) {
          this.initData()
        } else {
          const foundObj = { article: this.item.languages.find(x => x.lge_id === newValue) }
          let newObj
          if (foundObj.article === undefined) {
            newObj = {
              ale_name: undefined,
              ale_is_active: true,
              ale_description: undefined,
              ale_title_thin: undefined,
              ale_title: undefined,
              gap: true,
              items: [],
            }
            this.image.selected = []
          } else {
            newObj = {
              gap: foundObj.article.ale_content.gap,
              ale_name: foundObj.article.ale_name,
              ale_is_active: foundObj.article.ale_is_active,
              ale_description: foundObj.article.ale_description,
              ale_title_thin: foundObj.article.ale_title_thin,
              ale_title: foundObj.article.ale_title,
              items: foundObj.article.ale_content.items,
            }
            this.image.selected = []
            foundObj.article.ale_content.items.forEach((value, key) => {
              let facebook, twitter, instagram
              if (value.social.length > 0) {
                facebook = value.social.find(x => x.name === 'facebook')
                twitter = value.social.find(x => x.name === 'twitter')
                instagram = value.social.find(x => x.name === 'instagram')
              }
              this.image.selected.push(value.image)
              this.form.getFieldDecorator(`name[${key}]`)
              this.form.getFieldDecorator(`job[${key}]`)
              this.form.getFieldDecorator(`instagram[${key}]`)
              this.form.getFieldDecorator(`twitter[${key}]`)
              this.form.getFieldDecorator(`facebook[${key}]`)
              this.form.setFields({
                ['facebook[' + key + ']']: { value: facebook !== undefined ? facebook.link : undefined },
                ['twitter[' + key + ']']: { value: twitter !== undefined ? twitter.link : undefined },
                ['instagram[' + key + ']']: { value: instagram !== undefined ? instagram.link : undefined },
                ['name[' + key + ']']: { value: value.name, errors: value.name === undefined || value.name.trim().length === 0 ? ['Nadpis musí být vyplněn!'] : undefined },
                ['job[' + key + ']']: { value: value.job, errors: value.job === undefined || value.job.trim().length === 0 ? ['Práce musí být vyplněn!'] : undefined },
              })
            })
          }
          this.form.setFieldsValue(newObj)
          this.image.trigger = !this.image.trigger
          if (!this.loaded.includes(this.language)) {
            this.initDetail()
          }
        }
        this.form.validateFields()
      }
    },
  },
}
</script>

<style lang="scss" module>
  @import "./style.module.scss";
</style>
